import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/Index'
import MyHouse from '@/components/MyHouse' // 我的房屋list
import MyIdentity from '@/components/MyIdentity' // 添加房屋信息认证
import SelectCommunity from '@/components/SelectCommunity' // 添加我的房屋
import Payment from '@/components/Payment' // 物业缴费
// import CurrencyInfo from '@/components/CurrencyInfo' // 关于物业币
// import PrePayment from  '@/components/PrePayment'//预支付页面用于获取支付openId用
import SuccessPay from  '@/components/SuccessPay' // 成功缴费页面
import ToPay from '@/components/ToPay' // 支付订单页面
import SearchCommunity from '@/components/SearchCommunity' // 搜索房屋 
Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      name:'Index',
      component:Index
    },
    {
      path: '/MyHouse',
      name: 'MyHouse',
      component: MyHouse
    },
    {
      path: '/MyIdentity',
      name: 'MyIdentity',
      component: MyIdentity
    },
    {
      path: '/SelectCommunity',
      name: 'SelectCommunity',
      component: SelectCommunity
    },
    {
      path: '/Payment',
      name: 'Payment',
      component: Payment
    },
    // {
    //   path: '/CurrencyInfo',
    //   name: 'CurrencyInfo',
    //   component: CurrencyInfo
    // },
    // {
    //   path:'/PrePayment',
    //   name:'PrePayment',
    //   component:PrePayment
    // },
    {
      path:'/SuccessPay',
      name:'SuccessPay',
      component:SuccessPay
    },
    {
      path:'/ToPay',
      name:'ToPay',
      component:ToPay
    },
    {
      path: '/SearchCommunity',
      name: 'SearchCommunity',
      component: SearchCommunity
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js